import { useEffect, useState } from "react";
import UpcomingService from "./upcomingService";
import CompletedService from "./completedService";
import CancledService from "./camcledService";
import { useLocation, useNavigate } from "react-router-dom";
import { MdKeyboardBackspace } from "react-icons/md";

export default function Main() {
  const [activeStep, setActiveStep] = useState(1);
  const steps = [
    { id: 1, label: "Upcoming Service" },
    { id: 2, label: "Completed Service" },
    { id: 3, label: "Cancelled Service" },
  ];
   const location = useLocation();

  useEffect(() => {
    if (location.state?.activeStep) {
      setActiveStep(location.state.activeStep);
    }
  }, [location.state?.activeStep]);

  const navigate=useNavigate();
  return (
    <div className="bg-white px-6 py-10 md:px-4 xl:px-20 flex flex-col gap-6">
      
      <div className="flex flex-col md:flex-row gap-2 md:gap-4 text-xs md:text-sm xl:text-base items-center">
        <div className="flex flex-row justify-start items-start md:items-center md:mb-5" onClick={()=>navigate(-1)}>
          <MdKeyboardBackspace className="text-base md:text-lg xl:text-xl" />
        </div> 

        {steps.map((step) => (
          <button
            key={step.id}
            onClick={() => setActiveStep(step.id)}
            className={`px-4 py-2 rounded border border-gray-600 font-semibold w-48 ${
              activeStep === step.id
                ? "bg-[#A63F40] text-white"
                : "bg-white text-gray-700"
            }`}
          >
            {step.label}
          </button>
        ))}
      </div>

      <div className="flex-1">
        {activeStep === 1 && <UpcomingService />}
        {activeStep === 2 && <CompletedService />}
        {activeStep === 3 && <CancledService />}
      </div>
      
    </div>
  );
}
